import { render } from "./ai-text-box-dictionary.vue?vue&type=template&id=6cad39e3&scoped=true"
import script from "./ai-text-box-dictionary.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-text-box-dictionary.vue?vue&type=script&setup=true&lang=js"

import "./ai-text-box-dictionary.vue?vue&type=style&index=0&id=6cad39e3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cad39e3"],['__file',"src/components/ai-text-box-dictionary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cad39e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cad39e3', __exports__)) {
    api.reload('6cad39e3', __exports__)
  }
  
  module.hot.accept("./ai-text-box-dictionary.vue?vue&type=template&id=6cad39e3&scoped=true", () => {
    api.rerender('6cad39e3', render)
  })

}


export default __exports__